import AxiosApi from '../../api/AxiosApi';

import { getLocalStorage } from '../../cache/LocalstorageCache';

import { HttpRequestContract } from '../../../domain/contract/HttpContract';

import { HttpStatusCodeEnum } from '../../../domain/enums/HttpStatusCodeEnum';
import { LocalStorageKeysConstant } from '../../../main/constant/LocalStorageKeysConstant';

type ApiResponse = {
  statusCode: any;
  headers: any;
  body: any;
};

/**
 * CrudCall - chamadas do crud tem que passar o token
 * @param request
 * @constructor
 */
export async function CrudCall(request: HttpRequestContract) {
  let axiosResponse: ApiResponse = {
    statusCode: null,
    headers: null,
    body: null,
  };

  const KEY_TOKEN_USER_LOGIN = LocalStorageKeysConstant.tokenUserLogin ?? 'intelidente-token-login';
  const tokenApplication = getLocalStorage(KEY_TOKEN_USER_LOGIN);

  AxiosApi.defaults.headers.common = {
    Authorization: `Bearer ${tokenApplication.auth}`,
  };

  console.info('REQUEST ', request);

  await AxiosApi.request({
    url: request.url,
    method: request.method,
    data: request.body,
    headers: request.headers,
  })
    .then((response) => {
      axiosResponse = {
        statusCode: response.status,
        headers: response.headers,
        body: response.data,
      };
      console.info('RESPONSE ', axiosResponse);
    })
    .catch((error) => {
      axiosResponse = {
        statusCode: error.response.status,
        headers: error.response.headers,
        body: error.response.data,
      };
      console.error('RESPONSE ERROR ', axiosResponse);
    });

  if (axiosResponse.statusCode === HttpStatusCodeEnum.unauthorized) {
    window.location.href = '/erro-token';
  }

  return axiosResponse;
}
